import axios from 'axios'

const BASE_URL = 'https://apis.postcode-jp.com/api/v6'
const API_KEY = 'jrRmYx502sS07ihoNbPO7cKzmpvhxr7eCizuPQD'

export default {
  async getAddressesFromZipCode(zipCode, params = {}) {
    const response = await axios.get(`${BASE_URL}/postcodes/${zipCode}`, {
      headers: {
        apikey: API_KEY
      },
      params
    })
    return response.data
  }
}
